import IndexTable from '@lib/components/index-table/IndexTable';
import ProjectIndexTableRow from '../projects/ProjectIndexTableRow';
import * as React from 'react';

export default class ProjectsTable extends IndexTable {
    rowComponentClass = ProjectIndexTableRow
}
